import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  input,
  output,
  resource,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { Autocomplete } from '@lib/autocomplete';

import { Auth, UserService } from '../service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lcm-po-select',
  template: `
    <mat-form-field>
      <mat-label>{{ label() }}</mat-label>
      <input matInput [(ngModel)]="value" [matAutocomplete]="auto.autocomplete()" #input />
      <button matIconButton (click)="value.set('')" matSuffix><mat-icon>close</mat-icon></button>
      <lcm-autocomplete #auto="lcmAutocomplete" [options]="options()" [pattern]="input.value" />
    </mat-form-field>
  `,
  imports: [MatInputModule, MatAutocompleteModule, MatIconModule, MatButtonModule, Autocomplete, FormsModule],
})
export class PoSelect {
  auth = inject(Auth);
  userService = inject(UserService);

  label = input('Product Owner');
  poSelected = output<string>();

  value = signal('');

  constructor() {
    effect(() => {
      const value = this.value();
      this.poSelected.emit(value);
    });
  }

  users = resource({
    params: () => ({ users: this.userService.users() }),
    defaultValue: [],
    loader: async ({ params }) => {
      let users = params.users;
      // Filter to active users only and sort: current user first, then alphabetically by email
      users = users
        .filter((u) => u.State === 'active')
        .sort(({ Email: a }, { Email: b }) => {
          if (a === b) return 0;
          if (a === this.auth.email()) return -1;
          if (b === this.auth.email()) return 1;
          return a.localeCompare(b);
        });

      // Map to autocomplete options with special label for current user
      return users.map((u) => ({
        value: u.FullName,
        label: this.auth.email() === u.Email ? `Me (${u.FullName})` : u.FullName,
        key: u.FullName.toLowerCase(),
      }));
    },
  });
  options = computed(() => this.users.value());
}
